import { useLocation, useHistory } from 'react-router-dom';

export const useSearchParams = () => {
  const history = useHistory();
  const location = useLocation();

  const params = new URLSearchParams(location.search);

  const setParams = (array) => {
    array.forEach((e) => {
      if (!e.value && e.value !== false) params.delete(e.name);
      else params.set(e.name, e.value);
    });
    history.push({
      pathname: location.pathname,
      search: params.toString(),
    });
  };

  const deleteParams = (array) => {
    array.forEach((e) => {
      params.delete(e.name);
    });
    history.push({
      pathname: location.pathname,
      search: params.toString(),
    });
  };

  return [params, setParams, deleteParams];
};
